@if (accessToAllRequiredAppsAndEditions$ | async; as accessToAllRequiredAppsAndEditions) {
  @if (pricing$ | async; as pricing) {
    @if (product$ | async; as product) {
      @if (appData$ | async; as appData) {
        <store-product-details-v2
          [product]="product"
          [partnerId]="partnerId"
          [marketId]="marketId"
          [appTags]="appData"
          [marketingType]="marketingType.EndUser"
          [personaType]="PersonaType.SMB"
          [billingPrice]="pricing"
          [appPrice]="appPrice"
          [addonPrices]="addonPrices$ | async"
          [currency]="currency"
          [editionsMarketing]="editionsMarketing$ | async"
          [headerActionType]="headerActionType"
          [isEditionActionUsed]="isEditionActionUsed"
          [hasAccessToAllRequiredAppsAndEditions]="accessToAllRequiredAppsAndEditions.hasAccess"
          [onlyShowContactActionWhenHeaderActionIsDisabled]="true"
          [hideTags]="this.hideTags"
          (headerActionClick)="handleHeaderButtonClick()"
          (addonSelected)="handleAddonClick($event)"
          (editionActionClick)="editionActionClick.emit($event)"
          (contactActionClick)="handleContactActionClick()"
        ></store-product-details-v2>
      }
    }
  }
}
